import { Display_Units_Enum } from "gql/api";
import { usOilFieldUnits } from "./us_oil_field";
import { canadianOilFieldUnits } from "./canadian_oil_field";
import { europeGeothermalUnits } from "./europe_geothermal";
import { turkeyGeothermalUnits } from "./turkey_geothermal";
import { usWaterWellUnits } from "./us_water_well";
import { europeanOilField } from "./european_oil_field";
import { usHpsStbd } from "./us_hps_stbd";
import { internationalHps } from "./international_hps";

import type { Maybe } from "graphql/jsutils/Maybe";
import { usHpsGm } from "./us_hps_gm";
import { InternationalHpsM3d } from "./international_hps_m3d";

export type UnitPresets = {
  "Generic.Power.Hydraulic": string;
  "Generic.Power.Real": string;
  "Generic.Power.Apparent": string;
  "Generic.Current": string;
  "Generic.Density": string;
  "Generic.FlowRate.Liquid": string;
  "Generic.FlowRate.Gas": string;
  "Generic.Length.Large": string;
  "Generic.Length.Small": string;
  "Generic.Ratio.Liquid": string;
  "Generic.Mass": string;
  "Generic.Pressure": string;
  "Generic.Speed": string;
  "Generic.Temperature": string;
  "Generic.Viscosity": string;
  "Generic.Voltage": string;
  "Generic.Volume": string;
  "Generic.VolumeRate.PI": string;
  "Generic.Concentration": string;
  [overrideKey: string]: string;
};

const permanentOverrides = {
  "Oil Gravity.write.API": "API",
  "Oil Gravity.convert.API": "API",
  "Condensate API.write.API": "API",
  "Water Gravity.write.Specific Gravity": "Specific Gravity",
  "Water Gravity.convert.Specific Gravity": "Specific Gravity",
  "Amine Gravity.write.Specific Gravity": "Specific Gravity",
  "Amine Gravity.convert.Specific Gravity": "Specific Gravity",
  "Gas Gravity.write.Specific Gravity": "Specific Gravity",
  "Gas Gravity.convert.Specific Gravity": "Specific Gravity"
};

export const loadUnitPreset = (presetName: Maybe<string>): UnitPresets => {
  switch (presetName?.toLowerCase()) {
    case Display_Units_Enum.CanadianOilField:
      return { ...canadianOilFieldUnits, ...permanentOverrides };
    case Display_Units_Enum.EuropeGeothermal:
      return { ...europeGeothermalUnits, ...permanentOverrides };
    case Display_Units_Enum.TurkeyGeothermal:
      return { ...turkeyGeothermalUnits, ...permanentOverrides };
    case Display_Units_Enum.UsWaterWell:
      return { ...usWaterWellUnits, ...permanentOverrides };
    case Display_Units_Enum.EuropeOilField:
      return { ...europeanOilField, ...permanentOverrides };
    case Display_Units_Enum.UsHps:
      return { ...usHpsStbd, ...permanentOverrides };
    case Display_Units_Enum.UsHpsGm:
      return { ...usHpsGm, ...permanentOverrides };
    case Display_Units_Enum.InternationalHps:
      return { ...internationalHps, ...permanentOverrides };
    case Display_Units_Enum.InternationalHpsM3d:
      return { ...InternationalHpsM3d, ...permanentOverrides };

    case Display_Units_Enum.UsOilField:
    default:
      return { ...usOilFieldUnits, ...permanentOverrides };
  }
};

export const presetNameShowsOilRates = (
  presetName?: Maybe<string> | null
): boolean => {
  // Whenever US Water Well/Europe Geothermal/Turkey Geothermal is selected
  // as the unit type for a scenario, the reports pages should exclude any oil references

  // true as long as it's not one of....
  return ![
    Display_Units_Enum.UsWaterWell,
    Display_Units_Enum.EuropeGeothermal,
    Display_Units_Enum.TurkeyGeothermal
  ].includes(presetName?.toLowerCase() as Display_Units_Enum);
};
